import React from "react";
import PatientHealthIDLookup from "./components/PatientHealthIDLookup";
import PractitionerHealthIDLookup from "./components/PractitionerHealthIDLookup";
import { useTranslation } from "react-i18next";

function HealthIDLookup() {
  const { t } = useTranslation();

  return (
    <div className="w-full !p-0">
      <div className="mb-2 flex items-center justify-between">
        <span className="font-semibold text-black/70 text-lg">
          {t("Health ID Lookup")}
        </span>
      </div>

      <div className="grid grid-cols-1 gap-3 xl:grid-cols-2">
        <PatientHealthIDLookup />
        <PractitionerHealthIDLookup />
      </div>
    </div>
  );
}

export default HealthIDLookup;
